"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunitySessionDto = instanceOfOrientationOpportunitySessionDto;
exports.OrientationOpportunitySessionDtoFromJSON = OrientationOpportunitySessionDtoFromJSON;
exports.OrientationOpportunitySessionDtoFromJSONTyped = OrientationOpportunitySessionDtoFromJSONTyped;
exports.OrientationOpportunitySessionDtoToJSON = OrientationOpportunitySessionDtoToJSON;
exports.OrientationOpportunitySessionDtoToJSONTyped = OrientationOpportunitySessionDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationOpportunitySessionDto interface.
 */
function instanceOfOrientationOpportunitySessionDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('isDateTimeNegotiable' in value) || value['isDateTimeNegotiable'] === undefined)
        return false;
    return true;
}
function OrientationOpportunitySessionDtoFromJSON(json) {
    return OrientationOpportunitySessionDtoFromJSONTyped(json, false);
}
function OrientationOpportunitySessionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'isDateTimeNegotiable': json['isDateTimeNegotiable'],
    };
}
function OrientationOpportunitySessionDtoToJSON(json) {
    return OrientationOpportunitySessionDtoToJSONTyped(json, false);
}
function OrientationOpportunitySessionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'isDateTimeNegotiable': value['isDateTimeNegotiable'],
    };
}
//# sourceMappingURL=OrientationOpportunitySessionDto.js.map